import axios from '../getAxios';
import { passwordResetRequestPayloadProps } from '../types';

export default async (payload: passwordResetRequestPayloadProps) => {
  const { data } = await axios({
    method: 'POST',
    url: '/api/auth/password-reset/request',
    data: payload,
  });
  return data;
};
